"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uuid = exports.Uuid = exports.uuidMatcher = void 0;
const stdlib_core_1 = require("@groupby/stdlib-core");
exports.uuidMatcher = /\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/i;
class Uuid {
    constructor(formatted) {
        this[Symbol.toStringTag] = 'Uuid';
        assertFormattedUuid(formatted);
        this.formatted = formatted;
    }
}
exports.Uuid = Uuid;
function uuid(formatted) {
    return new Uuid(formatted);
}
exports.uuid = uuid;
function assertFormattedUuid(subject) {
    if (!(typeof subject === 'string' && exports.uuidMatcher.test(subject))) {
        throw new stdlib_core_1.IllegalArgumentException('The provided value is not a valid formatted UUID.');
    }
}
//# sourceMappingURL=uuid.js.map